let config = {
    //接口域名
    apiUrl: 'https://beitun.zhaoshang.pw/api',
    dcsApiBaseUrl : "http://dcsapi.com/?k=328719278",
    upload: '/upload',
    //企查查域名
    qichachaUrl: 'https://www.qichacha.com',
    //百度地址
    baiduUrl: 'https://www.baidu.com',
    //IOS下载地址
    iosAppUrl : 'https://itunes.apple.com/cn/app/linkmore/id1543362381?mt=8',
};
//完整上传
config.uploadUrl = config.apiUrl + config.upload;

export default config;




// WEBPACK FOOTER //
// ./src/config.js